import { TagsManagerGridView } from '../view/TagsManagerGridView';
import { templateTagsManagerGrid } from '../view/template';
import { TagsManagerGridRepository } from '../repository/TagsManagerGridRepository';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { TagsManagerGridWebComponent } from '..';
import { ButtonEvents } from '../../../ui/gzButton/types';
import { OnAddTag, OnDeleteTag } from '../events/events';
import { GridEvents } from '../../../grid/types/common';
import { showToast } from '../../helpers/commonFunctions';
import { ToastSeverity } from '../../../ui/gzToastNotification/type';

export class TagsManagerGridController extends BaseWebComponentController {
  public component: TagsManagerGridWebComponent;
  public dataRepository: TagsManagerGridRepository;
  public view: TagsManagerGridView;
  public viewConstructor: typeof TagsManagerGridView;
  public dataRepositoryConstructor: typeof TagsManagerGridRepository;

  private selectedItemsGridIds: Array<string> = [];

  constructor(component: TagsManagerGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: TagsManagerGridView,
      viewTemplate: templateTagsManagerGrid,
      dataRepositoryConstructor: TagsManagerGridRepository,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$addTagButton,
        event: ButtonEvents.CLICK,
        callback: this.emitAddTagEvent,
      },
      {
        element: this.view.dom.$deleteTagsButton,
        event: ButtonEvents.CLICK,
        callback: this.emitDeleteTagsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.SELECT_ROWS,
        callback: this.onGridRowsSelectedEvent,
      },
    ];
  }

  async getDataForView() {
    return this.dataRepository.getDataForView();
  }

  private emitAddTagEvent() {
    // TODO: discuss use case
    //if (
    //  this.view.dom.$grid.controller?.view.dom.$gridFooter.numTotalItems &&
    //  this.view.dom.$grid.controller.view.dom.$gridFooter.numTotalItems >= 100
    //) {
    //  // do not open Create tag window and display a toast notification
    //  showToast(
    //    ToastSeverity.WARNING,
    //    this.dependencies.translateFn(
    //      'You have reached the maximum number of tags allowed. Delete some older tags before adding new ones.'
    //    )
    //  );
    //} else {
      this.view.dom.$grid.dispatchEvent(new OnAddTag());
    //}
  }

  private emitDeleteTagsEvent() {
    const selectedGzTagsIds = this.selectedItemsGridIds.map(selectedItemGridData => ({ _id: selectedItemGridData }));
    this.view.dom.$grid.dispatchEvent(
      new OnDeleteTag(
        selectedGzTagsIds,
        this.view.dom.$grid.isAllSelected,
        this.view.dom.$grid.controller?.view.dom.$gridFooter.numTotalItems || 0
      )
    );
  }

  private onGridRowsSelectedEvent(event: WebComponentEvent) {
    if (event.detail.selectionStoreData && event.detail.selectionStoreData.length !== 0) {
      this.selectedItemsGridIds = event.detail.selectionStoreData;
    } else {
      this.selectedItemsGridIds = event.detail.selectedItemsData.map(selectedItemData => selectedItemData._id);
    }
    this.updateDeleteButtonState();
  }

  private updateDeleteButtonState() {
    this.view.dom.$deleteTagsButton.disabled = !(this.selectedItemsGridIds && this.selectedItemsGridIds.length > 0);
  }
}
